// Global console override for production and third-party script filtering

const isProduction = process.env.NODE_ENV === 'production';
const isDebugEnabled = process.env.REACT_APP_DEBUG === 'true';

// Patterns to filter out third-party script logs (Jane/MJ Tag, etc.)
const thirdPartyPatterns = [
  '[MJ]',
  'cnna.io',
  'herb.co',
  'Adapter Context',
  'SDK URL:',
];

// Check if a log message is from a third-party script
const isThirdPartyLog = (...args: any[]): boolean => {
  const message = args.map(arg =>
    typeof arg === 'string' ? arg : JSON.stringify(arg)
  ).join(' ');
  return thirdPartyPatterns.some(pattern => message.includes(pattern));
};

// Store original methods
const originalConsole = {
  log: console.log.bind(console),
  debug: console.debug.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console)
};

if (isProduction && !isDebugEnabled) {
  // In production: suppress all console output
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};

  // Provide a way to restore console for debugging if needed
  (window as any).__restoreConsole = () => {
    Object.assign(console, originalConsole);
    originalConsole.log('Console restored for debugging');
  };
} else {
  // In development: filter out third-party script noise
  console.log = (...args: any[]) => {
    if (!isThirdPartyLog(...args)) originalConsole.log(...args);
  };
  console.debug = (...args: any[]) => {
    if (!isThirdPartyLog(...args)) originalConsole.debug(...args);
  };
  console.info = (...args: any[]) => {
    if (!isThirdPartyLog(...args)) originalConsole.info(...args);
  };
  console.warn = (...args: any[]) => {
    if (!isThirdPartyLog(...args)) originalConsole.warn(...args);
  };
  console.error = (...args: any[]) => {
    if (!isThirdPartyLog(...args)) originalConsole.error(...args);
  };
}

export {};